import React from 'react';
import { connect } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    videoPreview: {
        overflow: 'hidden'
    },
    progress: {
        width: 60,
        height: 60,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
        display: 'none'
    }
});

const BackgroundStockVideoPlayer = (props) => {
    const { classes, backgroundStockVideoPreviewData } = props;

    return (!backgroundStockVideoPreviewData) ? null : (
        <>
            <CircularProgress 
                className={classes.progress} 
            />
            <video 
                className={classes.videoPreview}
                src={backgroundStockVideoPreviewData.urls.exampleUrl} 
                width='910' 
                height='510' 
                frameBorder='0'
                crossOrigin='anonymous'
                muted 
                allow='autoplay; fullscreen; picture-in-picture' 
                allowFullScreen
                controls 
                title='Specterr Catalog Video'
            >
            </video>
        </>
    );
};

const mapStateToProps = (state) => {
    const { backgroundStockVideoPreviewData } = state.mediaPicker;
    return { backgroundStockVideoPreviewData };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(BackgroundStockVideoPlayer, styles));